export enum EpicBreakpointInPx {
	"medium" = 576,
	"large" = 992,
	"xlarge" = 1200,
	"xxlarge" = 1400,
}
